export function defineCustomElement(Component, customTag = 'display-ad-component') {
    if (!customElements.get(customTag)) {
        customElements.define(customTag, Component);
    }
}
